import api from './api';

// Foros
const getForums = async (classroomId) => {
    try {
        const response = await api.get(`/classroom-forum/classroom/${classroomId}`);
        return response.data;
    } catch (error) {
        if (error?.response?.status === 204) return [];
        throw error;
    }
};

const getForum = async (forumId) => {
    try {
        const response = await api.get(`/classroom-forum/${forumId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const createForum = async (forumData) => {
    try {
        const response = await api.post(`/classroom-forum`, forumData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const updateForum = async (forumData) => {
    try {
        const response = await api.put(`/classroom-forum`, forumData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const deleteForum = async (forumId) => {
    try {
        const response = await api.delete(`/classroom-forum/${forumId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Publicaciones (temas raíz + respuestas)
const getTopics = async (forumId) => {
    try {
        const response = await api.get(`/classroom-forum/${forumId}/topics`);
        return response.data;
    } catch (error) {
        if (error?.response?.status === 204) return [];
        throw error;
    }
};

const getThread = async (forumId, postId) => {
    try {
        const response = await api.get(`/classroom-forum/${forumId}/topics/${postId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const createPost = async (postData) => {
    try {
        const response = await api.post(`/classroom-forum/post`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const updatePost = async (postData) => {
    try {
        const response = await api.put(`/classroom-forum/post`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const deletePost = async (postId) => {
    try {
        const response = await api.delete(`/classroom-forum/post/${postId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export default {
    getForums,
    getForum,
    createForum,
    updateForum,
    deleteForum,
    getTopics,
    getThread,
    createPost,
    updatePost,
    deletePost
};
